import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { saveActionDescription, saveActionGroupNumber } from '@app/actions/scenes/currentSceneCreating'
import { syncGroupsScenes } from '@app/actions/scenes/groupsScenes/groupsScenes'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectGroupAction
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/GroupActions/GroupsList/SelectGroupAction'
import SelectGroupActionIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/GroupActions/GroupsList/SelectGroupAction'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRefresh, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectGroupActionIOS) : withStyles(SelectGroupAction)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { groupsScenes } = state.scenes.groupsScenes
  return {
    isMobile,
    groupsScenes,
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  refresh: syncGroupsScenes,
  tryAgain: syncGroupsScenes,
  notifications: syncNotifications.sync,
  saveActionDescription,
  saveActionGroupNumber,
}, dispatch)

enhance = withRefresh(enhance)
enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectGroupActionEnhanced = enhance

export default withRouter(SelectGroupActionEnhanced)
